import { Dog } from './dog';

export class StudDog extends Dog {
    id = 0;
    studFee: number;
}
